import { api } from "./client";
import type {
  CursorPage,
  RunDetail,
  RunSnapshot,
  RunSummary,
} from "./types";

export interface RunFilters {
  status?: string;
  limit?: number;
}

export const runsPage = (
  cursor: string | null,
  filters: RunFilters = {},
): Promise<CursorPage<RunSummary>> => {
  const qs = new URLSearchParams();
  if (cursor) qs.set("cursor", cursor);
  if (filters.status) qs.set("status", filters.status);
  qs.set("limit", String(filters.limit ?? 50));
  return api(`/api/runs?${qs}`);
};

export const getRun = (id: string) => api<RunDetail>(`/api/runs/${id}`);

export const createRun = (
  urls: string[],
  options: { source?: string; forceRescan?: boolean; checkIds?: string[] | null } = {},
) =>
  api<{ run_id: string | null }>("/api/runs", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      urls,
      source: options.source ?? "ui-upload",
      force_rescan: options.forceRescan ?? false,
      check_ids: options.checkIds ?? null,
    }),
  });

export const runSnapshots = (id: string, since?: string) => {
  const qs = since ? `?since=${encodeURIComponent(since)}` : "";
  return api<RunSnapshot[]>(`/api/runs/${id}/snapshots${qs}`);
};

export interface CloseSyncResponse {
  was_skipped: boolean;
  was_full: boolean;
  count: number;
  started_at: string | null;
  finished_at: string | null;
  backgrounded: boolean;
}

export const closeSync = (full = false) =>
  api<CloseSyncResponse>(
    `/api/close/sync${full ? "?full=true" : ""}`,
    { method: "POST" },
  );

export interface CloseSyncStatus {
  in_progress: boolean;
  running_force_full: boolean;
  running_processed: number;
  running_started_at: string | null;
  last_synced_at: string | null;
  last_sync_count: number;
  last_sync_was_full: boolean;
}

export const cancelRun = (id: string) =>
  api<{ cancelled: boolean }>(`/api/runs/${id}/cancel`, { method: "POST" });

export const pauseRun = (id: string) =>
  api<{ paused: boolean }>(`/api/runs/${id}/pause`, { method: "POST" });

export const resumeRun = (id: string) =>
  api<{ resumed: boolean }>(`/api/runs/${id}/resume`, { method: "POST" });
